<template>
  <div class="home">
    <TopoContrato />
    <div class="row">
      <!-- Conteudo das views -->
      <div v-show="!perfilTitular" style="width: 100%" class="mt-5 text-center">
        <h4 class="text-center mb-2" style="width: 100%">Aguardando Assinatura do Contrato</h4>
        <div style="text-align: -moz-center">
          <div style="width: 100%; overflow-x: auto; height: 300px">
            <div>Sua assinatura está pendente aguardando o titular assinar o aceite do contrato.</div>
          </div>
        </div>
      </div>
      <div v-show="perfilTitular">
        <h4 class="text-center mb-2">Termos do Contrato</h4>
        <div style="text-align: -moz-center">
          <div style="width: 90%; overflow-x: auto; height: 300px">
            <div v-html="conteudoContrato"></div>
          </div>
          <div class="mt-2" v-html="conteudoAssinatura"></div>
        </div>
        <br class="clear" />
        <div class="col-md-12 text-center mb-1">
          <button type="button" class="btn btn-primary" @click="concordarContrato">Concordo com os termos</button>
        </div>
      </div>
      <!--Fim conteudo view -->
    </div>
  </div>
</template>

<script>
import TopoContrato from "@/components/TopoContrato.vue";

const optionsAlert = { title: "Mensagem", size: "sm" };

export default {
  mounted() {
    this.carregarContrato();
  },
  name: "contrato",
  components: {
    TopoContrato,
  },
  data() {
    return {
      conteudoContrato: '',
      conteudoAssinatura: '',
      selecionadaSubscription: 0,
      perfilTitular: false
    };
  },
  methods: {
    carregarContrato() {
      this.perfilTitular = (localStorage.getItem("profile") === "HOLDER");
      let subscriptionId = localStorage.getItem("subscription");
      this.$clubApi.post("/subscription/generate/contract-file/load/" + subscriptionId)
        .then((response) => {
          this.conteudoContrato = response.data;
          this.conteudoAssinatura = "Esse contrato será assinado virtualmente pelo Sr(a). " +
            localStorage.getItem("name") + " em " + this.obterDataHora();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          NProgress.done();
        });
    },
    concordarContrato() {
      this.$clubApi.post(`/subscription/contract/accepted/${localStorage.getItem("subscription")}`)
        .then((response) => {
          if (response.data) {
            location.href = "/home";
          }
        })
        .catch((error) => {
          this.$dialogs.alert(error.response.data.msg, optionsAlert);
        })
        .finally(() => {
          NProgress.done();
        });
    },
    obterDataHora() {
      let dataAtual = new Date();
      let dia = dataAtual.getDate() < 10 ? "0" + dataAtual.getDate() : dataAtual.getDate();
      let mes = dataAtual.getMonth() + 1 < 10 ? "0" + (dataAtual.getMonth() + 1) : dataAtual.getMonth() + 1;
      let hora = dataAtual.getHours() < 10 ? "0" + dataAtual.getHours() : dataAtual.getHours();
      let minuto = dataAtual.getMinutes() < 10 ? "0" + dataAtual.getMinutes() : dataAtual.getMinutes();
      let segundo = dataAtual.getSeconds() < 10 ? "0" + dataAtual.getSeconds() : dataAtual.getSeconds();
      return (dia + "/" + mes + "/" + dataAtual.getFullYear() + " " + hora + ":" + minuto + ":" + segundo);
    },
  },
};
</script>

<style scoped>
.rounded {
  border-radius: 1rem !important;
}
</style>

 